module.exports = __webpack_public_path__ + "static/media/clothing-accessories.7ec3783c.svg";